"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MainImage = _interopRequireDefault(require("./MainImage.vue"));
var _enum = require("../../enum");
var _internal = require("@/components/uploadPicture/internal.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'batchSet',
  components: {
    MainImageVue: _MainImage.default
  },
  data: function data() {
    return {
      goodsStatusEnum: _enum.goodsStatusEnum,
      cpStatusEnum: _enum.cpStatusEnum,
      tableData: [{
        image: []
      }]
    };
  },
  methods: {
    batchAdd: function batchAdd() {
      this.$emit('updataAttrValue', this.tableData[0]);
      this.tableData = [{
        image: []
      }];
    },
    attrImage: function attrImage(row) {
      var _this = this;
      // 使用Windows本地文件上传方式
      window.$loading = this.$loading;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        model: 'product',
        pid: 1,
        onSuccess: function onSuccess(url) {
          _this.$set(_this.tableData[0], 'attrImage', url);
          _this.$message.success('图片上传成功');
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '上传失败');
        }
      });
    },
    handleMainImage: function handleMainImage(row) {
      this.$refs.mainImageRef.open(row.image);
    },
    mainImageList: function mainImageList(data) {
      this.tableData[0].image = data;
    },
    changeCpStatus: function changeCpStatus(index) {
      var cpStatus = this.tableData[index].cpStatus;
      if (cpStatus !== 3) {
        this.$set(this.tableData[index], 'listStatus', '');
      }
    },
    // 只有已入库才能上架
    changeListStatus: function changeListStatus(index) {
      var _this$tableData$index = this.tableData[index],
        cpStatus = _this$tableData$index.cpStatus,
        listStatus = _this$tableData$index.listStatus;
      if (cpStatus !== 3 && listStatus === 1) {
        this.$message.warning('只有已入库才能上架');
        this.$set(this.tableData[index], 'listStatus', '');
      }
    }
  }
};